import { render, staticRenderFns } from "./CoursePackageCourse.vue?vue&type=template&id=57d1ab1a&scoped=true"
import script from "./CoursePackageCourse.vue?vue&type=script&lang=js"
export * from "./CoursePackageCourse.vue?vue&type=script&lang=js"
import style0 from "./CoursePackageCourse.vue?vue&type=style&index=0&id=57d1ab1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d1ab1a",
  null
  
)

export default component.exports